import {Feature, Map as OlMap, View} from 'ol';
import {Tile} from "ol/layer";
import {OSM, Vector} from "ol/source";
import VectorLayer from "ol/layer/Vector";
import {LineString, Point, Polygon} from "ol/geom";
import {decode} from "../Styles";
import {get as getProj} from 'ol/proj';
import {Attribution} from "ol/control";

const defaults = {
    hasPolygons: true,
    hasPoints: true,
    hasLines: true
};

export default function (target, {styles, baseLayer, ...theRest }) {
    const {
        hasPolygons,
        hasPoints,
        hasLines
    } = { ...defaults, ...theRest,  };

    const point = new Point([171.3, -42.4]);

    const polygon = new Polygon(
        [[
            [171, -42],
            [172, -41],
            [173, -43],
            [171, -42]
    ]]);

    const line = new LineString(
        [
        [172, -43.4],
        [173, -43.5],
        [171, -44],
    ]);

    let projection = baseLayer ? baseLayer.getSource().getProjection() : getProj('EPSG:3857');

    const features = [hasPoints && point, hasPolygons && polygon, hasLines && line ]
        .filter(p => !!p)
        .map(g => g.transform('EPSG:4326', projection))
        .map(geometry => new Feature({ geometry }));

    const vectorLayer = new VectorLayer({
        source: new Vector({
            features
        }),
        style: styles ? decode(styles) : undefined
    });

    const view = new View({ projection })

    let theBaseLayer = baseLayer || new Tile({ source: new OSM() });
    const map = new OlMap({
        target,
        layers: [
            theBaseLayer,
            vectorLayer
        ],
        controls: [new Attribution({ collapsible: false })],
        interactions: [],
        view
    });

    const fit = () => view.fit(vectorLayer.getSource().getExtent(),
        { size: map.getSize(), padding: [10, 10, 10, 10] });
    fit();

    window.addEventListener('resize', fit);

    return {
        update({styles/*, baseLayer*/}) {
            if (styles) {
                try {
                    vectorLayer.setStyle(decode(styles));
                } catch (e) {
                    console.warn(e);
                }
            }

            /*if (baseLayer !== theBaseLayer) {
                requestAnimationFrame(() => {
                    const proj = baseLayer.getSource().getProjection();
                    map.getLayers().setAt(0, baseLayer);

                    if (proj.getCode() !== projection.getCode()) {
                        vectorLayer.getSource().getFeatures().forEach(f => f.getGeometry().transform(projection, proj));
                        projection = proj;
                        map.setView(new View({ projection }))
                        fit();
                    }

                    theBaseLayer = baseLayer;
                });
            }*/
        },
        destroy() {
            console.log('destroying map');
            window.removeEventListener('resize', fit);
        }
    }
}